import { cn } from '@/lib/utils'

/** Loading placeholder block — size it with className (`h-3.5 w-40`, …). */
export function Skeleton({ className }: { className?: string }) {
  return <div aria-hidden="true" className={cn('animate-pulse rounded-sm bg-bone/70', className)} />
}

/** `lines` stacked text-height skeletons; the last line runs short. */
export function SkeletonText({ lines = 3, className }: { lines?: number; className?: string }) {
  return (
    <div aria-hidden="true" className={cn('space-y-2', className)}>
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton key={index} className={cn('h-3.5', index === lines - 1 && 'w-3/5')} />
      ))}
    </div>
  )
}
